import { render, staticRenderFns } from "./PersonalArmamentoComponent.vue?vue&type=template&id=ef27ce72&scoped=true"
import script from "./PersonalArmamentoComponent.vue?vue&type=script&lang=js"
export * from "./PersonalArmamentoComponent.vue?vue&type=script&lang=js"
import style0 from "./PersonalArmamentoComponent.vue?vue&type=style&index=0&id=ef27ce72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef27ce72",
  null
  
)

export default component.exports